import { adminHttpClient } from '../../../commons/adminHttpClient'

export interface BillingInformation {
  billingEmail: string
}

const updateBillingEmail = (values: BillingInformation): Promise<any> => {
  return adminHttpClient.put('/AdminDashboard/CompanySettings/CompanySubscription/UpdateBillingEmail', values)
}

export default updateBillingEmail
